import React from "react";
import { TextField as MatTextField, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Ride",
    textTransform: "none",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    // to be used for text on white background
    color: theme.hertzColors.eightyBlack,
  },
  // to be used for text on yellow background
  ninetyBlack: {
    color: theme.hertzColors.ninetyBlack,
  },
}));

const TextField = (props) => {
  const classes = useStyles();
  let style = `${classes.root}`;
  style = `${style} ${classes[props.color]}`;
  style = `${style} ${classes[props.variant]}`;

  return (
    <MatTextField
      className={style}
      margin="normal"
      variant="outlined"
      {...props}
    />
  );
};

export default TextField;
